import { isColorBright, resolveColorProperty } from '@gn-audio/jss-components';

type TableCellProps = {
  background: string;
  children: React.ReactNode;
  colspan?: number;
};

const TableCell = ({ background, children, colspan }: TableCellProps) => {
  const backgroundHex = resolveColorProperty(background);
  const textColorClass = isColorBright(backgroundHex) ? 'text-black' : 'text-white';
  return (
    <td
      className="h-full border border-gray-200"
      style={{ backgroundColor: backgroundHex }}
      colSpan={colspan}
    >
      <div className={`flex h-full items-center p-3 text-lg md:p-5 md:text-xl ${textColorClass}`}>
        {children}
      </div>
    </td>
  );
};

export default TableCell;
